import { errorSlice } from './slice';

export const {
  showErrorPopup: showErrorPopupAction,
  hideErrorPopup: hideErrorPopupAction,
} = errorSlice.actions;
